export default __webpack_public_path__ + "static/media/Path3461.119fa96c.svg";